import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HighlightTextPipe } from '../../../../pipes/highlight-text.pipe';
import { NkDatatableAbstractColumnComponent } from '../../datatable.utils';
import { isLinkColumnItem, LinkColumnItem } from '../column-components.utils';

@Component({
  selector: 'nk-link-column',
  imports: [CommonModule, HighlightTextPipe, RouterLink],
  templateUrl: './link-column.component.html',
  styleUrls: ['./link-column.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkColumnComponent<T> extends NkDatatableAbstractColumnComponent<T> {
  public link$: Observable<LinkColumnItem | null> = this.value$.pipe(
    map((value) => {
      if (value && value.row && value.prop) {
        const item = value.row && value.row[value.prop];
        if (isLinkColumnItem(item)) {
          return item;
        }
      }
      return null;
    }),
  );
}
